angular.module('wbControllers').controller(
  'DataImportsController',
  ['$scope', 'railsResource', '$routeParams', '$location',
  function($scope, $resource, $routeParams, $location) {
    const DataImport = $resource('/data_imports/:id', { id: '@id' }, {
      setImportToValid: { method: 'POST', url: '/data_imports/:id/set_import_to_valid' }
    });

    const Custodians = $resource('/custodians/:id', { id: '@id' });

    $scope.filters = {};
    $scope.custodians = Custodians.query();
    DataImport.query({ only_types: true }, results => $scope.types = results);

    $scope.archive = (di) => {
      if (confirm('Warning: This will remove all rows imported from this file from the database')) {
        di.$delete();
      }
    };

    $scope.unarchive = (di) => {
      if (confirm('Warning: This will restore all rows from this import to the database, but will archive any conflicting data imports from the same day.')) {
        di.$update();
      }
    };

    $scope.set_import_to_valid = (di) => {
      if (confirm('Warning: This will override the failed validation status & allow for this file to be picked up by the Data Importer')) {
        di.$setImportToValid();
      }
    };

    $scope.sort = (field) => {
      if ($scope.sortField === field) {
        $scope.reverse = !$scope.reverse;
      } else {
        $scope.reverse = false;
      }

      const search = {
        order: field,
        reverse: $scope.reverse
      };

      return $location.search(_.merge($location.search(), search));
    };

    $scope.updateFilters = () => {
      const search = {
        page: 1,
        type: $scope.filters.type,
        custodian: $scope.filters.custodian
      };
      return $location.search(_.merge($location.search(), search));
    };

    const loadDataImports = () => {
      $scope.filters.type = $location.search().type;
      $scope.filters.custodian = $location.search().custodian;
      $scope.page = $location.search().page ? $location.search().page : 1;
      $scope.sortField = $location.search().orderBy ? $location.search().orderBy : 'csvDate';
      $scope.reverse = ($location.search().reverse === true) || ($location.search().reverse === undefined) ? true : false;
      $scope.search = $location.search().search ? $location.search().search : undefined;

      return DataImport.get({
        search: $scope.search,
        page: $scope.page,
        orderBy: $scope.sortField,
        reverse: $scope.reverse,
        filters: $scope.filters
      }).$promise.then(dataImports => $scope.dataImports = dataImports);
    };

    if ($routeParams.id) {
      $scope.dataImport = DataImport.get($routeParams);
    } else {
      loadDataImports();
    }

    $scope.$on('$routeUpdate', () => loadDataImports());

    $scope.$watch(
      'search',
      () => $location.search(_.merge($location.search(), { search: $scope.search }))
    );
  }
]);
